module.exports = __webpack_public_path__ + "static/media/arrowRight.c0fe33ba.svg";